export default __webpack_public_path__ + "static/media/pdf.ed8b1376.svg";